<template>
  <div>
    <div class="card">
      <div class="card-content">
        <h4 class="card-title">Reporte de Movimientos</h4>
        <div class="row">
          <div class="col-md-6" v-if="getKey('permisos').includes(17)">
            <label class="control-label">Dependencia</label>
            <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" name="ente_publico_id" v-model="model.dependencia">
              <el-option v-for="option in dependencias" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
            </el-select>
          </div>
          <div class="col-md-6">
            <label class="control-label">Seleccione el movimiento a consultar</label>
            <el-select clearable class="select-default" filterable placeholder="Selecciona una opción" v-model="model.tipomov">
              <el-option v-for="option in movimientos" class="select-default" :value="option.value" :label="option.label" :key="option.label">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label class="control-label">
              Desde
            </label>
            <div class="form-group">
              <el-date-picker
                              name="fecha_inicio"
                              v-model="model.fecha_inicio"
                              format="dd-MM-yyyy" value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="Elige un día">
              </el-date-picker>
            </div>
          </div>
          <div class="col-md-6">
            <label class="control-label">
              Hasta
            </label>
            <div class="form-group">
              <el-date-picker
                              name="fecha_fin"
                              v-model="model.fecha_fin"
                              format="dd-MM-yyyy" value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="Elige un día">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 pull-right">
            <br>
            <button @click="getBitacora" class="btn btn-fill btn-success pull-right">
              Buscar
            </button>
          </div>
        </div>
        <br>

        <div>
          <br>
          <div class="row">
            <div class="col-sm-6">

              <export-excel
                            class="btn btn-wd btn-success"
                            :data="list_bitacora"
                            :meta="meta"
                            :fields="faltantes_campos"
                            worksheet="Movimientos"
                            name="Movimientos.xls">
                <span class="btn-label">
                  <i class="fa fa-file-excel"></i>
                </span>
                Descargar Reporte
              </export-excel>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
              <b-form-group>
                <b-input-group>
                  <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
          <div class="row mt-3 mb-4">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <v-data-table :headers="headers" :items="list_bitacora" :items-per-page="5" class="" :search="filter" :fixed-header="true">
                <template v-slot:item.usuario="{ item }">
                  <div>{{ getNombre(item.usuario) }}</div>
                </template>
              </v-data-table>

            </div>


          </div>
        </div>


      </div>
    </div>

  </div>
</template>
<script>
import Vue from 'vue'
import { Table, TableColumn, Select, Option, DatePicker } from 'element-ui'
import PPagination from 'src/components/UIComponents/Pagination.vue'
import moment from 'moment'
import excel from 'vue-excel-export'
/*   Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
 */

export default {
  components: {
    PPagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data () {
    return {
      model: {},
      // dependencias: {},
      rol: '',
      filter: null,
      currentPage: 1,
      perPage: 50,
      // periodos: [],
      model: {},
      rows: null,
      tiposDeclaracion: [],
      list_bitacora: [],

      filtro_usuarios: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      faltantes_campos: {
        'Tipo Movimiento': 'movimiento',
        'Fecha Solicitud': 'fecha',
        'Usuario': 'usuario',
        'RFC': 'rfc',
        'CURP': 'curp',
        'Nombre': 'nombre',
        'Dependencia': 'dependencia',
        'Area': 'area',
        'Cargo': 'cargo',
        'Inicio': 'iniio',
        'Termino': 'termino'

      },
      movimientos: [
        {
          value: '1',
          label: 'Todos'
        },
        {
          value: '0',
          label: 'Desactivar servidor'
        },
        {
          value: '2',
          label: 'Bajas '
        },
        {
          value: '4',
          label: 'Licencias'
        },
        {
          value: '3',
          label: 'Promociones'
        },
        {
          value: '5',
          label: 'Correcciones'
        },
        {
          value: '6',
          label: 'Cambiar contraseña'
        },
        {
          value: '7',
          label: 'Eliminar del Padrón'
        }
      ],
      searchQuery: '',
      headers: [{
        text: 'Tipo Movimiento',
        align: 'center',
        sortable: false,
        value: 'movimiento',
        class: '',
        width: 150
      }, {
        text: 'Fecha de Solicitud',
        value: 'fecha',
        align: 'center'
      }, {
        text: 'Validó',
        value: 'usuario',
        align: 'center'
      }, {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'CURP',
        value: 'curp',
        align: 'center'
      }, {
        text: 'Servidor Público',
        value: 'nombre',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'dependencia',
        align: 'center'
      }, {
        text: 'Área',
        value: 'area',
        align: 'center'
      }, {
        text: 'Cargo',
        value: 'cargo',
        align: 'center'
      }, {
        text: 'Inicio',
        value: 'inicio',
        align: 'center'
      }, {
        text: 'Termino',
        value: 'termino',
        align: 'center'
      }],
      fields_list: [{
        key: 'movimiento', label: 'Tipo Movimiento', thClass: 'td-small', tdClass: 'text-center td-small'
      },
      {
        key: 'fecha', label: 'Fecha', thClass: 'td-small', tdClass: 'text-center td-small'
      },
      {
        key: 'usuario', label: 'Usuario', thClass: 'td-small', tdClass: 'text-center td-small'
      },
      {
        key: 'rfc', label: 'RFC', thClass: 'td-small', tdClass: 'text-center td-small'
      },
      {
        key: 'curp', label: 'CURP', thClass: 'td-small', tdClass: 'text-left td-small'
      },
      {
        key: 'nombre', label: 'Nombre', thClass: 'td-small', tdClass: 'text-left td-small'
      },
      {
        key: 'dependencia', label: 'Dependencia', thClass: 'td-small', tdClass: 'text-left td-small'
      },
      {
        key: 'area', label: 'Area', thClass: 'td-small', tdClass: 'text-left td-small'
      },
      {
        key: 'cargo', label: 'Cargo', thClass: 'td-small', tdClass: 'text-left td-small'
      },
      {
        key: 'inicio', label: 'Inicio', thClass: 'td-small', tdClass: 'text-left td-small'
      },
      {
        key: 'termino', label: 'Termino', thClass: 'td-small', tdClass: 'text-left td-small'
      }]
    }
  },
  computed: {
    pagedData () {
      return this.list_bitacora.slice(this.from, this.to)
    },
    queriedData () {
      if (!this.searchQuery) {
        this.pagination.total = this.list_bitacora.length
        return this.pagedData
      }
      let result = this.list_bitacora
        .filter((row) => {
          let isIncluded = false
          for (let key of this.propsToSearch) {
            let rowValue = row[key].toString()
            if (rowValue.includes && rowValue.includes(this.searchQuery)) {
              isIncluded = true
            }
          }
          return isIncluded
        })
      this.pagination.total = result.length
      return result.slice(this.from, this.to)
    },
    to () {
      let highBound = this.from + this.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.perPage * (this.currentPage - 1)
    },
    total () {
      // console.log(this.list_bitacora.length);
      this.rows = this.list_bitacora.length

      return this.list_bitacora.length
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {

    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.rows = filteredItems.length
      this.currentPage = 1
    },
    checkPermissions () {
      let permiso = [11, 17]
      if (!this.getKey('permisos').some(r => permiso.includes(r))) {
        localStorage.clear()
        this.$router.push('/login')
        this.$router.go()
      }
    },
    // getDependencias(index) {
    //   this.$http.get("cat_ente_publico").then(
    //     response => {
    //       this.dependencias = response.data.entes_publicos;
    //     },
    //     error => {
    //       this.StepError(error);
    //       console.log(error);
    //     }
    //   );
    // },
    dateFormat (date) {
      return moment(fecha, 'DD/MM/YYYY').format('DD/MM/YYYY')
    },
    getMovimiento (tipo) {
      switch (tipo) {
        case 0:
          return 'Desactivar servidor'
        case 2:
          return 'Bajas'
        case 4:
          return 'Licencias'
        case 3:
          return 'Promociones'
        case 5:
          return 'Correccion'
        case 6:
          return 'Cambiar Contraseña'
        case 7:
          return 'Eliminar del Padrón'
      }
    },
    getBitacora () {
      if (!(this.model.tipomov != '' && this.model.dependencia != '' && this.model.fecha_inicio != '' && this.model.fecha_fin)) {
        this.StepW('Llena todos los campos')
        return
      }

      this.$http.get('movimientos/' + this.model.tipomov + '/' + this.model.dependencia + '/' + this.model.fecha_inicio + '/' + this.model.fecha_fin).then(
        response => {
          var v = this
          v.list_bitacora = []
          console.log(response.data.movimiento)
          $.each(response.data.movimiento, function (key, value) {
            v.list_bitacora.push({
              'rfc': value.usuarios.rfc,
              'fecha': v.dateFormat(value.created_at),
              'curp': value.usuarios.curp,
              'nombre': value.usuarios.nombres + ' ' + value.usuarios.primer_apellido + ' ' + value.usuarios.segundo_apellido,
              'dependencia': value.encargo.ente.valor,
              'area': value.encargo.area_adscripcion,
              'cargo': value.encargo.empleo_cargo_comision,
              'usuario': value.usuario,
              'movimiento': v.getMovimiento(value.tipo_mov),
              'inicio': v.dateFormat(value.inicia),
              'termino': v.dateFormat(value.termina)
            })
          })
        },
        error => {
          this.StepError(error)
        }
      )
    },
    dateFormat: function (date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    getNombre (usuario) {
      if (usuario) { return usuario.Nombre + ' ' + usuario.Paterno + ' ' + usuario.Materno } else { return 'Sin aprobar' }
    }
  },
  created () {
    this.rol = this.getKey('role')
    this.checkPermissions()
    // this.getDependencias()
    if (!this.getKey('permisos').includes(17))// permiso de declaraciones global
    { this.model.dependencia = this.getKey('ente_publico_id') }
  },
  mounted () {
    this.checkCatalogs()
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/Movimientos.vue